import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
function CopyError() {
  return /*#__PURE__*/_jsx(UIErrorMessage, {
    type: "notFound",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "ui-multi-account-asset-copier.panel.copyError.title"
    }),
    children: /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ui-multi-account-asset-copier.panel.copyError.description"
      })
    })
  });
}
export default CopyError;